var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "modal-linkedin",
            title: "Add LinkedIn Content",
            "hide-footer": "",
            size: "lg",
            centered: "",
          },
          on: { hidden: _vm.resetForm },
        },
        [
          _c("validation-observer", {
            ref: "observer",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var handleSubmit = ref.handleSubmit
                  var invalid = ref.invalid
                  return [
                    _c(
                      "b-form",
                      {
                        on: {
                          submit: function ($event) {
                            $event.preventDefault()
                            return handleSubmit(_vm.validateAndSubmit2)
                          },
                        },
                      },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Post Name",
                                      "label-for": "campaign_name",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "campaign name",
                                        vid: "Campaign Name",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    placeholder:
                                                      "Enter Post name",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  on: {
                                                    blur: _vm.validateCampaignName,
                                                  },
                                                  model: {
                                                    value: _vm.campaignName,
                                                    callback: function ($$v) {
                                                      _vm.campaignName = $$v
                                                    },
                                                    expression: "campaignName",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "6" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Budget",
                                      "label-for": "budget",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required|numeric|min_value:1",
                                        name: "cost",
                                        vid: "cost",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-input", {
                                                  attrs: {
                                                    type: "number",
                                                    placeholder: "Enter Budget",
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  on: {
                                                    blur: _vm.validateCost,
                                                  },
                                                  model: {
                                                    value: _vm.cost,
                                                    callback: function ($$v) {
                                                      _vm.cost = $$v
                                                    },
                                                    expression: "cost",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Template",
                                      "label-for": "email_template",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        name: "email template",
                                        vid: "Email Template",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("b-form-select", {
                                                  attrs: {
                                                    options:
                                                      _vm.templateOptions,
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  on: {
                                                    change: _vm.selectTemplate,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedTemplateId,
                                                    callback: function ($$v) {
                                                      _vm.selectedTemplateId =
                                                        $$v
                                                    },
                                                    expression:
                                                      "selectedTemplateId",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-col",
                              { attrs: { md: "12" } },
                              [
                                _c(
                                  "b-form-group",
                                  {
                                    attrs: {
                                      label: "Content",
                                      "label-for": "email_content",
                                    },
                                  },
                                  [
                                    _c("validation-provider", {
                                      attrs: {
                                        rules: "required",
                                        name: "Content",
                                        vid: "Email Content",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (ref) {
                                              var errors = ref.errors
                                              return [
                                                _c("quill-editor", {
                                                  attrs: {
                                                    state:
                                                      errors.length > 0
                                                        ? false
                                                        : null,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.selectedTemplate
                                                        .content,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.selectedTemplate,
                                                        "content",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "selectedTemplate.content",
                                                  },
                                                }),
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [_vm._v(_vm._s(errors[0]))]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          { attrs: { md: "12" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label:
                                    "Upload Media (Accepted file types: Images (JPG, PNG, GIF,webp), Videos (MP4, AVI). Max size: 5MB per file. Max 2 files.)",
                                  "label-for": "upload_media",
                                },
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    rules: _vm.hasMedia ? "" : "required",
                                    name: "upload media",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (ref) {
                                          var errors = ref.errors
                                          return [
                                            _c("b-form-file", {
                                              attrs: {
                                                multiple: "",
                                                placeholder:
                                                  "Choose up to 2 files...",
                                                accept: "image/*,video/*",
                                              },
                                              on: {
                                                change:
                                                  _vm.convertFilesToBase64,
                                              },
                                              model: {
                                                value: _vm.files,
                                                callback: function ($$v) {
                                                  _vm.files = $$v
                                                },
                                                expression: "files",
                                              },
                                            }),
                                            _c(
                                              "small",
                                              { staticClass: "text-danger" },
                                              [_vm._v(_vm._s(errors[0]))]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.base64Files.length
                          ? _c(
                              "b-col",
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c("h5", [_vm._v("Uploaded Media:")]),
                                _c(
                                  "b-row",
                                  _vm._l(
                                    _vm.uploadedMedia,
                                    function (media, index) {
                                      return _c(
                                        "b-col",
                                        {
                                          key: "uploaded-" + index,
                                          staticClass: "mb-2",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "b-card",
                                            { staticClass: "preview-card" },
                                            [
                                              media.type === "photos"
                                                ? _c("b-img", {
                                                    staticClass:
                                                      "preview-media",
                                                    attrs: {
                                                      src: media.src,
                                                      alt: "Uploaded Image",
                                                    },
                                                  })
                                                : media.type === "videos"
                                                ? _c(
                                                    "video",
                                                    {
                                                      staticClass:
                                                        "preview-media",
                                                      attrs: { controls: "" },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          src: media.src,
                                                          type: "video/webm",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " Your browser does not support the video tag. "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "text-center mt-1 text-truncate",
                                                },
                                                [_vm._v(_vm._s(media.name))]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mt-1 w-100",
                                                  attrs: {
                                                    variant: "danger",
                                                    size: "sm",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeUploadedImage(
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Remove ")]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mt-1 w-100",
                                                  attrs: {
                                                    variant: "success",
                                                    size: "sm",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewImageSelected(
                                                        media.src
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Preview ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.selectedTemplateId
                          ? _c(
                              "b-col",
                              { staticClass: "mb-2", attrs: { cols: "12" } },
                              [
                                _c("h5", [_vm._v("Media Files:")]),
                                _c(
                                  "b-row",
                                  _vm._l(
                                    _vm.previewMedia,
                                    function (media, index) {
                                      return _c(
                                        "b-col",
                                        {
                                          key: index,
                                          staticClass: "mb-2",
                                          attrs: { cols: "3" },
                                        },
                                        [
                                          _c(
                                            "b-card",
                                            { staticClass: "preview-card" },
                                            [
                                              media.type === "photos"
                                                ? _c("b-img", {
                                                    staticClass:
                                                      "preview-media",
                                                    attrs: {
                                                      src: media.src,
                                                      alt: "Preview Image",
                                                    },
                                                  })
                                                : media.type === "videos"
                                                ? _c(
                                                    "video",
                                                    {
                                                      staticClass:
                                                        "preview-media",
                                                      attrs: { controls: "" },
                                                    },
                                                    [
                                                      _c("source", {
                                                        attrs: {
                                                          src: media.src,
                                                          type: "video/webm",
                                                        },
                                                      }),
                                                      _vm._v(
                                                        " Your browser does not support the video tag. "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass: "mt-1 w-100",
                                                  attrs: {
                                                    variant: "success",
                                                    size: "sm",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.previewImageSelected(
                                                        media.src
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(" Preview ")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "b-col",
                          {
                            staticClass: "d-flex justify-content-end",
                            attrs: { md: "12" },
                          },
                          [
                            _c(
                              "b-button",
                              { attrs: { type: "submit", variant: "primary" } },
                              [_vm._v("Save")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            size: "lg",
          },
          model: {
            value: _vm.showImageModal,
            callback: function ($$v) {
              _vm.showImageModal = $$v
            },
            expression: "showImageModal",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex justify-content-between align-items-center mb-2",
            },
            [
              _c("h5", { staticClass: "ml-2" }, [_vm._v("Image Preview")]),
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: { variant: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.showImageModal = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
          _c("b-img", {
            staticClass: "full-image",
            attrs: { src: _vm.selectedImage },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }